module.exports = __webpack_public_path__ + "img/thumbnail_GiantAnteater_m_albino.fe0a4a1a.png";